import reSourceService from "../ResourceService";
import {IQuyetDinhSinhVien} from '../../UIS_models/QuyetDinhSinhVien.model';
import {IHocPhanTuongDuong} from '../../UIS_models/HocPhanTuongDuong.model';
import {ILichThi} from '../../UIS_models/LichThi.model';
import { IChuongTrinhDaoTao } from "src/UIS_models/ChuongTrinhDaoTao.model";
import {IThongTinSinhVienCapNhat} from "src/UIS_models/CapNhatThongTinSinhVien";
const  urlEndpoint = "student";
const studentService = {
    //Get data thông tin sinh viên
    Get:() :Promise<any|null> =>{
        return reSourceService.get(`${urlEndpoint}/info`);
    },
    //Get data chi tiet chuong trình đào tạo
    GetStudyPrograms :(StudyProgramID:string):Promise<any|null> =>{
        return reSourceService.get(`${urlEndpoint}/studyProgram?StudyProgramID=${StudyProgramID}`);
    },
    //Get data quyết định sinh viên
    GetAllDecision :():Promise<IQuyetDinhSinhVien[] | []> =>{
        return reSourceService.get(`${urlEndpoint}/decision`);
    },
    //Get data học phần tương đương sinh viên
    GetAllEquivalentcourse :():Promise<IHocPhanTuongDuong[] | []> =>{
        return reSourceService.get(`${urlEndpoint}/equivalentcourse`);
    },
    //Get data năm học ,học kỳ
    GetYearAndTerm :():Promise<any |null> =>{
        return reSourceService.get(`${urlEndpoint}/yearandterm`);
    },
    //Get data lich thi sinh vien 
    GetAllExam:(namhoc,hocky):Promise<ILichThi[] |null> =>{
        return reSourceService.get(`${urlEndpoint}/exam?namhoc=${namhoc}&&hocky=${hocky}`);
    },
    //Get data lich thi sinh vien 
    GetAllExamByTime:():Promise<ILichThi[] |null> =>{
        return reSourceService.get(`${urlEndpoint}/showexambytime`);
    },
    //Get data chuong trinh dao tao sinh vien
    GetAllStudyProgram:():Promise<IChuongTrinhDaoTao[] | []> =>{
        return reSourceService.get(`${urlEndpoint}/getstudyprogram`);
    },
    GetStudentInfoUpdate:():Promise<IThongTinSinhVienCapNhat | null> =>{
        return reSourceService.get(`${urlEndpoint}/StudentInfoUpdate`);
    },
    UpdateStudent:(Student:any):Promise<any> =>{
        return reSourceService.post(`${urlEndpoint}/UpdateStudent`,Student);
    },
    GetAvatar:():Promise<any|null> =>{
        return reSourceService.get(`${urlEndpoint}/GetAvatar`);
    },
}
export default studentService;